import { type AttachedCsvFile } from 'shared/copilot/hooks/useCopilotCsvAttachment'

export type CsvRoutingMode = 'supplementary' | 'standalone' | 'platformOnly' | 'sessionOrNone'

export interface ResolveCsvRoutingModeArgs {
  hasSelectedDatasource: boolean
  attachedFile: AttachedCsvFile | null
}

/**
 * Determines how CSV signals are written to agent.state for the current send turn.
 */
export const resolveCsvRoutingMode = ({
  hasSelectedDatasource,
  attachedFile
}: ResolveCsvRoutingModeArgs): CsvRoutingMode => {
  if (hasSelectedDatasource && attachedFile != null) {
    return 'supplementary'
  }
  if (!hasSelectedDatasource && attachedFile != null) {
    return 'standalone'
  }
  if (hasSelectedDatasource) {
    return 'platformOnly'
  }
  return 'sessionOrNone'
}

export interface AgentCsvRoutingPatch {
  attach_csv_file?: { gcs_uri: string; filename: string } | null
  uploaded_csv_files?: Array<{ gcs_uri: string; filename: string }>
}

/** Top-level user message marker for supplementary CSV turns (matches Flow persist shape). */
export const getUserMessageCsvAttachMode = (mode: CsvRoutingMode): 'supplementary' | undefined =>
  mode === 'supplementary' ? 'supplementary' : undefined

export const buildAgentCsvRoutingPatch = (
  mode: CsvRoutingMode,
  attachedFile: AttachedCsvFile | null
): AgentCsvRoutingPatch => {
  switch (mode) {
    case 'supplementary':
      if (attachedFile == null) {
        return { attach_csv_file: null, uploaded_csv_files: [] }
      }
      return {
        attach_csv_file: null,
        uploaded_csv_files: [{ gcs_uri: attachedFile.gcsUri, filename: attachedFile.filename }]
      }
    case 'standalone':
      if (attachedFile == null) {
        return { attach_csv_file: null, uploaded_csv_files: [] }
      }
      return {
        attach_csv_file: { gcs_uri: attachedFile.gcsUri, filename: attachedFile.filename },
        uploaded_csv_files: []
      }
    case 'platformOnly':
      return { attach_csv_file: null, uploaded_csv_files: [] }
    case 'sessionOrNone':
      return { uploaded_csv_files: [] }
  }
}
